import api from "@/services/api";
import type { ApiResponse } from "@/types/api";
import type { DownloadRequest, ServiceStatus } from "@/features/downloads/types";
import env from "@/lib/env";

const BASE = env.managementApiUrl;

// POST /v1/downloads
export const queueDownload = async (req: DownloadRequest): Promise<{ queue_id: string }> => {
  const res = await api.post<ApiResponse<{ queue_id: string }>>(`${BASE}/v1/downloads`, req);
  return res.data.data;
};

// GET /v1/system/services
export const getServicesHealth = async (): Promise<ServiceStatus[]> => {
  const res = await api.get<ApiResponse<ServiceStatus[]>>(`${BASE}/v1/system/services`);
  return res.data.data;
};
